import { render, staticRenderFns } from "./NoGiftAlert.vue?vue&type=template&id=774babf3"
import script from "./NoGiftAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./NoGiftAlert.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports